module.exports = __webpack_public_path__ + "img/1-05.22ecff83.png";